import { Routes } from '@angular/router';

import { AppBlankComponent } from './app-blank/app-blank.component';

export const OthersRoutes: Routes = [
  {
    path: '',
    component: AppBlankComponent,
  }
];


// WEBPACK FOOTER //
// D:/Programing/carbooking/src/app/views/others/others.routing.ts